<template>
	<div>
		<!-- breadcrumb area -->
		<div class="breadcrumb-area breadcrumb-padding bg-img" :style="{backgroundImage:`url(${bgImg})`}">
		    <div class="container">
		        <div class="breadcrumb-content text-center">
		            <h2>产品</h2>
		        </div>
		    </div>
		</div>
		<!-- Project area -->
		<div class="section section-padding">
		    <div class="container">
		        <div class="row row-cols-lg-3 row-cols-md-2 row-cols-sm-2 row-cols-1 mb-n6">
		            <div class="col mb-6" v-for="(item,index) in productList" :key="item.id">
		                <div class="blog-wrap">
		                    <div class="blog-img mb-2">
								<router-link :to="{path:'/productDetail/'+item.id}"><img :src="item.image | imgfilter" alt=""></router-link>
		                    </div>
		                    <div class="blog-content d-flex">
								<div style="flex: 1;">
									<router-link :to="{path:'/productDetail/'+item.id}" class="thumbnail">
										{{item.name}}
									</router-link>
								</div>
								<div class="collent">
									<Icon v-if="item.isLike" style="cursor: pointer;" size="30" type="ios-heart" color="#ff495e" @click="collect(item)" />
									<Icon v-else style="cursor: pointer;" size="30" type="ios-heart-outline" @click="collect(item)" />
									<div>{{item.like_count}}</div>
								</div>
		                    </div>
		                </div>
		            </div>
		        </div>
		        <div class="pagination-style mt-lg-9 mt-md-7 mt-5">
					<div class="block">
					    <el-pagination
					      @current-change="handleCurrentChange"
						  :pager-count="5"
					      :current-page="currentPage"
					      layout="total, prev, pager, next"
					      :total="total">
					    </el-pagination>
					  </div>
		        </div>
		    </div>
		</div>
	</div>
</template>

<script>
	import { getCookies, removeCookies } from '@/libs/util'
	import {
		getProductList,
		ProductLikeAdd,
		ProductLikeDel
	} from '@/api'
	export default {
	    data() {
	      return {
			  nameInfo:'',
			bgImg: require('../static/images/banner/banner-3.jpg'),
	        currentPage: 1,
			productList: [],
			total: 0,
	      };
	    },
		created() {
		    this.getProductList()
		},
		computed: {
			isLogin() {
			  return getCookies("webtoken");
			},
		},
		methods: {
			
			// 获取产品列表
			async getProductList() {
			  const res = await getProductList({
				  page: this.currentPage,
				  limit: 9
			  })
			  this.total = res.data.count
			  this.productList = res.data.list
			},
			// 页码跳转
			handleCurrentChange(val) {
				this.currentPage = val
				this.getProductList()
				document.documentElement .scrollTop= 0
			},
			
			collect(item){
				if(!this.isLogin) {
					alert('请登录后操作')
					return false
				}
				if(item.isLike == 0){
					ProductLikeAdd({
						pro_id:item.id
					}).then((res)=>{
						if(res.status==200){
							item.isLike= 1
							item.like_count++
						}
					})
				}else{
					ProductLikeDel({
						pro_id:item.id
					}).then((res)=>{
						if(res.status==200){
							item.isLike= 0
							item.like_count--
						}
					})
				}
			},
		  
		},
	}
	
</script>

<style>
	.stick {
	  -webkit-animation: 700ms ease-in-out 0s normal none 1 running fadeInDown;
	          animation: 700ms ease-in-out 0s normal none 1 running fadeInDown;
	  box-shadow: 0 8px 20px 0 rgba(0, 0, 0, 0.1);
	  position: fixed;
	  top: 0;
	  width: 100%;
	  z-index: 999;
	  left: 0;
	  background-color: #ffffff;
	  transition: all 0.3s ease 0s;
	}
</style>
